namespace GeniuzPOS.InventoryReport {
    export interface IcReportWhsEomRow {
        Id?: string;
        SkuCode?: string;
        WhsId?: string;
        WhsName?: string;
        WhsType?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        QtyOnhand?: number;
        CostOnhand?: number;
        EndDate?: string;
    }

    export namespace IcReportWhsEomRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReportWhsEom';
        export const deletePermission = '2Inventory:รายงาน:สต๊อกคงเหลือสิ้นเดือน:View';
        export const insertPermission = '2Inventory:รายงาน:สต๊อกคงเหลือสิ้นเดือน:View';
        export const readPermission = '2Inventory:รายงาน:สต๊อกคงเหลือสิ้นเดือน:View';
        export const updatePermission = '2Inventory:รายงาน:สต๊อกคงเหลือสิ้นเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            QtyOnhand = "QtyOnhand",
            CostOnhand = "CostOnhand",
            EndDate = "EndDate"
        }
    }
}
